<template>
  <div class="animated fadeIn col-md-12">
    <SearchCard
      :filterCatch="true"
      :hasFilter="true"
      :title="$lang.access_report_list"
      :url="url"
      cardClass="border-0 p-3"
      ref="searchCard"
      @updatePermissions="updatePermissions"
      :hasAdd="true"
      @handleAdd="showAddModal"
    >
      <template slot="html" slot-scope="{ item }">
        <b-col
          cols="12"
          md="12"
          class="mb-3 pb-3 px-0 border border-top-0 border-right-0 border-left-0 border-light"
        >
          <b-row align-h="center">
            <b-col cols="" md="" class="fs_1rem font-weight-bold pb-md-0 pb-3">
              <ProfileBoxPopupWrapper
                :data="item.parvandeh"
                deskTopPopupClass="top-230"
                nameClass="color-complementary"
              />
              با شماره پرونده
              <span
                @click="goToParvandeh(item)"
                class="text-primary cursor_pointer"
                >{{ pathOr("", ["parvandeh", "parvandeh_number"], item) }}</span
              >
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" md="12">
          <b-row>
            <b-col cols="12" md="8" class="py-2">
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.report_accessible" />:
              <span v-if="pathOr([], ['report_accessible'], item).length">
                <b-badge
                  v-for="(row, i) in pathOr([], ['report_accessible'], item)"
                  :key="i"
                  variant="secondary"
                  v-text="row.caption"
                  class="m-1 p-1"
                />
              </span>
              <span v-else class="text-muted" v-text="$lang.all_reports" />
            </b-col>
            <b-col cols="12" md="4" class="py-1">
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.expire_at" />:
              <span
                class="text-muted"
                v-text="
                  pathOr('بدون محدودیت زمانی', ['expire_at', 'jalali'], item)
                "
              />
            </b-col>
            <b-col
              v-if="pathOr(null, ['description'], item)"
              cols="12"
              md="12"
              class="py-1"
            >
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.description" />:
              <span
                class="text-muted"
                v-text="pathOr('', ['description'], item)"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col
          cols="12"
          md="12"
          class="text-right pt-3 mt-3 px-0 border border-bottom-0 border-right-0 border-left-0 border-light"
        >
          <b-row align-v="center">
            <b-col
              cols="12"
              md="auto"
              class="text-md-left text-center text-muted pb-md-0 pb-3 d-flex align-items-center justify-content-center"
            >
              <div
                v-b-tooltip
                :title="$lang.created_by"
                v-if="
                  pathOr(null, ['created_by'], item) &&
                  pathOr(null, ['created_by'], item) !== getFullName(item)
                "
                class="mr-2"
              >
                <mdicon name="account-edit-outline" size="20" class="mr-1" />
                <span v-text="pathOr('', ['created_by'], item)" />
              </div>
              <div v-b-tooltip :title="$lang.create_time">
                <mdicon name="clock-edit-outline" size="20" class="mr-1" />
                <span
                  v-html="
                    createDateFormat(pathOr([], ['created_at', 'jalali'], item))
                  "
                />
              </div>
            </b-col>
            <b-col
              cols="12"
              md=""
              class="text-md-right text-center text-muted pb-md-0"
            >
              <ExpandButton
                variant="success"
                :expandable="true"
                :expanded="false"
                :disabled="false"
                :circle="true"
                :loading="false"
                icon="shield-edit-outline"
                :text="$lang.edit"
                :tooltip="$lang.edit"
                cls="mx-1"
                :condition="isAdmin(permissions)"
                @click="showEditModal(item)"
              />

              <ExpandButton
                variant="danger"
                :expandable="true"
                :expanded="false"
                :disabled="false"
                :circle="true"
                :loading="false"
                icon="close"
                :text="$lang.remove"
                :tooltip="$lang.remove"
                cls="mx-1"
                :condition="isAdmin(permissions, ['admin'])"
                @click="showRemoveConfirm(item)"
              />
            </b-col>
          </b-row>
        </b-col>
      </template>
    </SearchCard>
    <b-modal
      no-close-on-backdrop
      hide-header
      hide-footer
      v-model="addEditModal"
    >
      <EditReportAccess
        v-if="editingId"
        :id="editingId"
        @close="closeAddEditModal"
        @getData="getData"
      />
      <AddReportAccess v-else @close="closeAddEditModal" @getData="getData" />
    </b-modal>
    <Confirm
      :title="confirmData.title"
      :description="confirmData.description"
      v-model="confirmData.show"
      :ok-title="$lang.yes"
      :cancel-title="$lang.no"
      dynamicClass=""
      :loadingSpinnerText="$lang.removing_data"
      :loading="confirmData.loading"
      :preventDefault="true"
      @ok="removeItem()"
      @cancel="closeRemoveConfirm()"
    />
  </div>
</template>

<script>
import SearchCard from "@/components/base/searchCard";
import Confirm from "@/components/base/confirm";
import ExpandButton from "@/components/global/ExpandButton";
import AddReportAccess from "./addReportAccess.vue";
import EditReportAccess from "./editReportAccess.vue";
import { pathOr, includes } from "ramda";
import {
  isAdmin,
  calcPercentage,
  createDateFormat,
  generateApiUrl,
  goToRoute,
} from "@/shared/utils";
import { ProfileBoxPopupWrapper } from "@/components/re-design";

export default {
  name: "search-report-access",
  inject: ["reportAccessRepository"],
  components: {
    SearchCard,
    AddReportAccess,
    EditReportAccess,
    Confirm,
    ExpandButton,
    ProfileBoxPopupWrapper,
  },
  data() {
    return {
      permissions: [],
      addEditModal: false,
      editingId: null,
      confirmData: {
        show: false,
        loading: false,
        title: this.$lang.remove,
        description: this.$lang.are_you_sure_delete,
        id: null,
      },
    };
  },
  computed: {
    url() {
      return generateApiUrl(["profile", "report_access"]);
    },
  },
  methods: {
    pathOr,
    includes,
    isAdmin,
    calcPercentage,
    createDateFormat,
    generateApiUrl,
    goToParvandeh(item) {
      const parvandeh_number = pathOr(
        null,
        ["parvandeh", "parvandeh_number"],
        item
      );
      const name = "parvandeh_by_number";
      const params = { parvandeh_number };
      return goToRoute(name, params);
    },
    getData() {
      this.$refs.searchCard.getItems();
    },
    updatePermissions(data) {
      this.permissions = [...data];
    },
    getFullName(item) {
      return pathOr("", ["parvandeh", "person", "full_name"], item);
    },
    showAddModal() {
      this.editingId = null;
      this.addEditModal = true;
    },
    showEditModal(item) {
      this.editingId = pathOr(null, ["parvandeh", "code"], item);
      this.addEditModal = true;
    },
    closeAddEditModal() {
      this.addEditModal = false;
    },
    showRemoveConfirm(item) {
      this.confirmData.id = pathOr(null, ["parvandeh", "code"], item);
      this.confirmData.show = true;
    },
    closeRemoveConfirm() {
      this.confirmData.id = null;
      this.confirmData.show = false;
    },
    async removeItem() {
      try {
        this.confirmData.loading = true;
        const response = await this.reportAccessRepository.delete(
          this.confirmData.id
        );
        this.$notify.success(response.data.message);
        this.closeRemoveConfirm();
        this.getData();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.confirmData.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.grid-img-crd {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  img {
    width: 95px;
    height: auto;
  }
}
.fs_1_3rem {
  font-size: 20px;
}
.w_h_35 {
  width: 35px;
  height: 35px;
}
</style>
